import React from 'react';

export default function Loader() {
    return (
        <div className="c-loader" />
    );
}



// WEBPACK FOOTER //
// ./src/components/loader/index.jsx